import { gql } from "@apollo/client";

export const ADD_PIS = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        incident {
          id
        }
        person {
          id
          uuid
          personalAttribute {
            aliasName
            bilingual
            buildType {
              id
              name
              oriId
              position
              __typename
            }
            cell
            deceased
            distinguishingCharacteristics
            dob
            driversLicense
            email
            employer
            employerAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              __typename
            }
            eyeColor {
              id
              name
              oriId
              position
              __typename
            }
            facialHairType {
              id
              name
              oriId
              position
              __typename
            }
            fbiNumber
            firstName
            fishWildlifeLicense
            gender {
              id
              name
              oriId
              position
              __typename
            }
            hairColor {
              id
              name
              oriId
              position
              __typename
            }
            hairLength {
              id
              name
              oriId
              position
              __typename
            }
            height
            homeAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              validAddressAlerts {
                alertType {
                  id
                  name
                  alertLevel
                  oriId
                  position
                }
                expireAt
                id
                notes
                createdAt
                officer {
                  deptAttribute {
                    id
                    badge
                    ori {
                      id
                      abbreviation
                    }
                  }
                  personalAttribute {
                    id
                    firstName
                    lastName
                  }
                }
              }
              __typename
            }
            ibrArresteeRaceType {
              id
              name
              oriId
              position
              __typename
            }
            id
            juvenile
            lastName
            licenseState {
              id
              name
              oriId
              position
              __typename
            }
            mailingAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              __typename
            }
            mentalHealthAlert
            middleName
            nibrsGender {
              id
              name
              oriId
              position
              __typename
            }
            notes
            organization
            phone
            pobAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              __typename
            }
            race {
              id
              name
              oriId
              position
              __typename
            }
            residentType {
              id
              name
              oriId
              position
              __typename
            }
            sid
            substanceAbuseAlert
            suffix
            uuid
            violenceAlert
            waiverFine
            weaponsAlert
            weight
            work
            __typename
          }
        }
        bac
        yoe
        juvenile
        incidentInvolvement {
          id
          name
          oriId
          position
        }
      }
      errors
    }
  }
`;

export const UPDATE_PIS_INCIDENT_INVOLVEMENT = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        incidentInvolvement {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_PIS_VICTIM_TYPE = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        victimType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_PIS_BAC = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        bac
      }
    }
  }
`;

export const UPDATE_PIS_PERSON = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        person {
          id
          uuid
          personalAttribute {
            aliasName
            bilingual
            buildType {
              id
              name
              oriId
              position
              __typename
            }
            cell
            deceased
            distinguishingCharacteristics
            dob
            driversLicense
            email
            employer
            employerAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              __typename
            }
            eyeColor {
              id
              name
              oriId
              position
              __typename
            }
            facialHairType {
              id
              name
              oriId
              position
              __typename
            }
            fbiNumber
            firstName
            fishWildlifeLicense
            gender {
              id
              name
              oriId
              position
              __typename
            }
            hairColor {
              id
              name
              oriId
              position
              __typename
            }
            hairLength {
              id
              name
              oriId
              position
              __typename
            }
            height
            homeAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              validAddressAlerts {
                alertType {
                  id
                  name
                  alertLevel
                  oriId
                  position
                }
                expireAt
                id
                notes
                createdAt
                officer {
                  deptAttribute {
                    id
                    badge
                    ori {
                      id
                      abbreviation
                    }
                  }
                  personalAttribute {
                    id
                    firstName
                    lastName
                  }
                }
              }
              __typename
            }
            ibrArresteeRaceType {
              id
              name
              oriId
              position
              __typename
            }
            id
            juvenile
            lastName
            licenseState {
              id
              name
              oriId
              position
              __typename
            }
            mailingAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              __typename
            }
            mentalHealthAlert
            middleName
            nibrsGender {
              id
              name
              oriId
              position
              __typename
            }
            notes
            organization
            phone
            pobAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              __typename
            }
            race {
              id
              name
              oriId
              position
              __typename
            }
            residentType {
              id
              name
              oriId
              position
              __typename
            }
            sid
            substanceAbuseAlert
            suffix
            violenceAlert
            waiverFine
            weaponsAlert
            weight
            work
            __typename
          }
        }
      }
    }
  }
`;

export const UPDATE_PIS_CLOTHING = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        clothing
      }
    }
  }
`;
export const UPDATE_PIS_COMPUTER_USE = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        computerUse
      }
    }
  }
`;

export const UPDATE_PIS_DOC_STATUS = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        victimType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_PIS_DRUG_TYPES = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        drugTypes {
          id
          drugClassification {
            id
            name
            oriId
            position
          }
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_PIS_IBR_RESIDENT_TYPE = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        ibrResidentType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_PIS_INJURY_TYPES = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        injuryTypes {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_PIS_OPIATE_BLOCKER = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        opiateBlocker
      }
    }
  }
`;

export const UPDATE_PIS_ORPHANAGE = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        orphanage
      }
    }
  }
`;

export const UPDATE_PIS_PAPERWORK = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        paperwork {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_PIS_SEALED = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        sealed
      }
    }
  }
`;

export const UPDATE_PIS_STATEMENT_TAKEN_BY = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        statementTakenBy {
          id
          personalAttribute {
            lastName
            firstName
          }
          deptAttribute {
            badge
            id
            ori {
              id
              oriName
              abbreviation
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_PIS_STATEMENT_TYPE = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        statementType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_PIS_WEAPON_TYPE = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        weaponType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const ADD_OR_UPDATE_PERSON_IN_INCIDENT = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      personIncidentSpecific {
        id
        uuid
        person {
          aliases {
            id
            target {
              id
              personalAttribute {
                firstName
                middleName
                lastName
              }
              validPersonAlerts {
                id
                notes
                alertType {
                  name
                  alertLevel
                }
              }
            }
          }
          id
          uuid
          validPersonAlerts {
            alertType {
              id
              name
              alertLevel
            }
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
          personalAttribute {
            aliasName
            bilingual
            buildType {
              id
              name
              oriId
              position
              __typename
            }
            cell
            deceased
            distinguishingCharacteristics
            dob
            driversLicense
            email
            employer
            employerAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              __typename
            }
            eyeColor {
              id
              name
              oriId
              position
              __typename
            }
            facialHairType {
              id
              name
              oriId
              position
              __typename
            }
            fbiNumber
            firstName
            fishWildlifeLicense
            gender {
              id
              name
              oriId
              position
              __typename
            }
            hairColor {
              id
              name
              oriId
              position
              __typename
            }
            hairLength {
              id
              name
              oriId
              position
              __typename
            }
            height
            homeAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              validAddressAlerts {
                alertType {
                  id
                  name
                  alertLevel
                  oriId
                  position
                }
                expireAt
                id
                notes
                createdAt
                officer {
                  deptAttribute {
                    id
                    badge
                    ori {
                      id
                      abbreviation
                    }
                  }
                  personalAttribute {
                    id
                    firstName
                    lastName
                  }
                }
              }
              __typename
            }
            ibrArresteeRaceType {
              id
              name
              oriId
              position
              __typename
            }
            id
            juvenile
            lastName
            licenseState {
              id
              name
              oriId
              position
              __typename
            }
            mailingAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              __typename
            }
            mentalHealthAlert
            middleName
            nibrsGender {
              id
              name
              oriId
              position
              __typename
            }
            notes
            organization
            phone
            pobAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              __typename
            }
            race {
              id
              name
              oriId
              position
              __typename
            }
            residentType {
              id
              name
              oriId
              position
              __typename
            }
            sid
            substanceAbuseAlert
            suffix
            violenceAlert
            waiverFine
            weaponsAlert
            weight
            work
            __typename
          }
        }
        incidentInvolvement {
          id
          name
          oriId
          position
        }
      }
      errors
      incidentUuid
      personIncidentSpecificUuid
      personUuid
    }
  }
`;
